import util from '@bmp-vue/core/api/util'

const controller = 'QueueCallback'

export default Object.assign({}, util.GetCrud(controller, ['get']), {
    GetLogTentativasDisparo: function (currentQueueCallback) {
    const params = {
      Codigo: currentQueueCallback.codigo,
      OrigemTransacao: currentQueueCallback.origemTransacao,
      CodigoTransacao: currentQueueCallback.codigoTransacao,
      CodigoConta: currentQueueCallback.codigoConta
    }

    return util.Axios.Post(controller + '/GetLogTentativasDisparo', params)
  },
  GetAll (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller, dto)
  }
})
